export default {
  // 主要页面
  'pages.open-service.title': '开通服务',
  'pages.open-service.subTitle':
    '管理用户服务开通状态，为用户开通或关闭相关服务',
  'pages.open-service.currentSelection': '当前选择：',
  'pages.open-service.breadcrumb.serviceManagement': '服务管理',
  'pages.open-service.breadcrumb.openService': '开通服务',
  'pages.open-service.batchAdd': '批量新增',

  // 左侧树形结构
  'pages.open-service.tree.title': '楼栋楼层房屋选择',
  'pages.open-service.tree.buildingFloorHouse': '楼栋楼层房屋',

  // 表格相关
  'pages.open-service.table.title': '开通服务列表',
  'pages.open-service.table.allData': '全部数据',
  'pages.open-service.table.overdueData': '逾期数据',
  'pages.open-service.table.addService': '新增服务',
  'pages.open-service.table.pagination.total':
    '第 {start}-{end} 条/总共 {total} 条',

  // 表格列
  'pages.open-service.table.columns.index': '序号',
  'pages.open-service.table.columns.buildingName': '楼栋',
  'pages.open-service.table.columns.houseInfo': '房屋信息',
  'pages.open-service.table.columns.ownerName': '业主姓名',
  'pages.open-service.table.columns.serviceName': '服务名称',
  'pages.open-service.table.columns.serviceName.placeholder': '请选择服务名称',
  'pages.open-service.table.columns.unitPrice': '单价',
  'pages.open-service.table.columns.serviceStatus': '服务状态',
  'pages.open-service.table.columns.startDate': '开始日期',
  'pages.open-service.table.columns.endDate': '结束日期',
  'pages.open-service.table.columns.remarks': '备注',
  'pages.open-service.table.columns.operations': '操作',
  'pages.open-service.table.columns.view': '查看',
  'pages.open-service.table.columns.openService': '开通服务',

  // 状态标签
  'pages.open-service.status.enabled': '已启用',
  'pages.open-service.status.disabled': '已停用',

  // 操作消息
  'pages.open-service.message.serviceEnableSuccess': '服务启用成功',
  'pages.open-service.message.serviceDisableSuccess': '服务停用成功',
  'pages.open-service.message.operationFailed': '操作失败',
  'pages.open-service.message.batchDeleteSuccess': '批量删除成功',
  'pages.open-service.message.batchDeleteFailed': '批量删除失败',
  'pages.open-service.message.selectRecordsToDelete': '请选择要删除的记录',
  'pages.open-service.message.getDataFailed': '获取数据失败',
  'pages.open-service.message.batchDeleteConfirm':
    '确定要删除选中的 {count} 条记录吗？',
  'pages.open-service.message.batchEnableConfirm.title': '批量开通服务',
  'pages.open-service.message.batchEnableConfirm.content':
    '确认批量为所有房屋开通默认的基础物业服务吗？',
  'pages.open-service.message.batchEnableConfirm.ok': '确认',
  'pages.open-service.message.batchEnableConfirm.cancel': '取消',
  'pages.open-service.message.batchEnableSuccess':
    '已加入任务队列，请稍后查看创建结果。',
  'pages.open-service.message.batchEnableFailed':
    '批量开通服务失败，请稍后重试。',

  // 详情弹窗
  'pages.open-service.detail.title': '开通服务详情',
  'pages.open-service.detail.houseInfo': '房屋信息',
  'pages.open-service.detail.houseNumber': '房屋信息',
  'pages.open-service.detail.ownerName': '业主姓名',
  'pages.open-service.detail.serviceInfo': '服务信息',
  'pages.open-service.detail.serviceName': '服务名称',
  'pages.open-service.detail.unitPrice': '单价',
  'pages.open-service.detail.serviceStatus': '服务状态',
  'pages.open-service.detail.servicePeriod': '服务周期',
  'pages.open-service.detail.startDate': '开始日期',
  'pages.open-service.detail.endDate': '结束日期',
  'pages.open-service.detail.remarksInfo': '备注信息',
  'pages.open-service.detail.remarks': '备注',
  'pages.open-service.detail.noRemarks': '无备注信息',

  // Modal相关
  'pages.open-service.modal.editTitle': '编辑服务',
  'pages.open-service.modal.openTitle': '开通服务',
  'pages.open-service.modal.batchOpenTitle': '批量开通服务',
  'pages.open-service.modal.selectServiceCategory': '选择服务分类',
  'pages.open-service.modal.editHint': '编辑服务信息（可切换其他服务项）',
  'pages.open-service.modal.houseId': '房屋ID',
  'pages.open-service.modal.selectHouse': '请选择房屋',
  'pages.open-service.modal.selectOwner': '选择业主',
  'pages.open-service.modal.selectOwner.placeholder': '请选择业主',
  'pages.open-service.modal.startDate': '开始时间',
  'pages.open-service.modal.startDate.placeholder': '请选择开始时间',
  'pages.open-service.modal.endDate': '结束时间',
  'pages.open-service.modal.endDate.placeholder': '请选择结束时间（可选）',
  'pages.open-service.modal.serviceStatus': '服务状态',
  'pages.open-service.modal.serviceStatus.placeholder': '请选择服务状态',
  'pages.open-service.modal.parkingSpace': '停车位',
  'pages.open-service.modal.selectParkingSpace': '选择停车位',
  'pages.open-service.modal.selectParkingSpace.placeholder': '请选择停车位',
  'pages.open-service.modal.remarks': '备注',
  'pages.open-service.modal.remarks.placeholder': '请输入备注信息（可选）',
  'pages.open-service.modal.selectServiceItem': '选择服务项',
  'pages.open-service.modal.originalService': '原服务',
  'pages.open-service.modal.selected': '已选择',
  'pages.open-service.modal.serviceDetails': '服务详情',
  'pages.open-service.modal.selectedServiceDetails': '选中服务详情',
  'pages.open-service.modal.serviceName': '服务名称',
  'pages.open-service.modal.unitPrice': '单价',
  'pages.open-service.modal.billingUnit': '计费单位',
  'pages.open-service.modal.billingCycle': '计费周期',
  'pages.open-service.modal.serviceDescription': '服务介绍',
  'pages.open-service.modal.confirmBatchOpen': '确认批量开通',
  'pages.open-service.modal.selectServiceToOpen': '请选择要开通的服务',
  'pages.open-service.modal.batchOpenHint.title': '批量开通提示：',
  'pages.open-service.modal.batchOpenHint.content':
    '系统将为所有房屋开通此服务，已存在的不会重复开通，不存在的将全部开通服务。',
  'pages.open-service.modal.selectSpecificService': '选择要开通的具体服务项',
  'pages.open-service.modal.houseId2': '房屋ID',
  'pages.open-service.modal.search': '查询',
  'pages.open-service.modal.confirmOpen': '确认开通',
  'pages.open-service.modal.backToServiceCategory': '返回服务分类',
  'pages.open-service.modal.selectServiceToOpen2': '请选择要开通的服务项',
  'pages.open-service.modal.batchOpenService': '批量开通',
  'pages.open-service.modal.openService': '开通服务',

  // 表单验证
  'pages.open-service.form.validation.selectHouse': '请选择房屋',
  'pages.open-service.form.validation.selectOwner': '请选择业主',
  'pages.open-service.form.validation.selectStartDate': '请选择开始时间',
  'pages.open-service.form.validation.selectServiceStatus': '请选择服务状态',
  'pages.open-service.form.validation.selectParkingSpace': '请选择停车位',

  // 操作成功消息
  'pages.open-service.success.serviceEditSuccess': '服务编辑成功！',
  'pages.open-service.success.serviceOpenSuccess': '服务开通成功！',
  'pages.open-service.success.batchOpenSuccess':
    '批量开通成功！共开通 {count} 条服务记录',

  // 操作失败消息
  'pages.open-service.error.serviceEditFailed': '编辑服务失败',
  'pages.open-service.error.serviceOpenFailed': '开通服务失败',
  'pages.open-service.error.batchOpenFailed': '批量开通服务失败',

  // 房屋选择器
  'pages.open-service.houseSelector.title': '房屋选择器',
  'pages.open-service.houseSelector.tree.title': '楼栋楼层房屋选择',
  'pages.open-service.houseSelector.table.title': '房屋列表',
  'pages.open-service.houseSelector.table.title.withSelection':
    '房屋列表 - {building} {floor}',
  'pages.open-service.houseSelector.table.empty.forBuilding':
    '请选择楼栋楼层查看房屋信息',
  'pages.open-service.houseSelector.table.empty.noSelection': '暂无房屋数据',
  'pages.open-service.houseSelector.columns.select': '选择',
  'pages.open-service.houseSelector.columns.floor': '楼层',
  'pages.open-service.houseSelector.columns.houseNumber': '房屋编号',
  'pages.open-service.houseSelector.columns.ownerName': '业主姓名',
  'pages.open-service.houseSelector.columns.ownerPhone': '业主电话',
  'pages.open-service.houseSelector.columns.area': '面积',
  'pages.open-service.houseSelector.action.confirm': '确认',
  'pages.open-service.houseSelector.action.cancel': '取消',
  'pages.open-service.houseSelector.message.selectHouse': '请选择一个房屋',
  'pages.open-service.houseSelector.error.loadTree': '加载楼栋楼层房屋数据失败',
  'pages.open-service.houseSelector.error.loadHouses': '加载房屋列表失败',
  'pages.open-service.houseSelector.pagination.total':
    '第 {start} 到 {end} 共 {total} 条',

  // 停车位选择器
  'pages.open-service.parkingSelector.title': '选择停车位',
  'pages.open-service.parkingSelector.tree.title': '停车位区域',
  'pages.open-service.parkingSelector.table.title': '停车位列表',
  'pages.open-service.parkingSelector.selected': '已选择: {number}',
  'pages.open-service.parkingSelector.columns.parkingNumber': '车位编号',
  'pages.open-service.parkingSelector.columns.building': '楼栋',
  'pages.open-service.parkingSelector.columns.location': '位置',
  'pages.open-service.parkingSelector.columns.area': '区域',
  'pages.open-service.parkingSelector.columns.type': '类型',
  'pages.open-service.parkingSelector.columns.status': '状态',
  'pages.open-service.parkingSelector.columns.owner': '业主',
  'pages.open-service.parkingSelector.columns.vehicleBinding': '车辆绑定',
  'pages.open-service.parkingSelector.status.bound': '已绑定',
  'pages.open-service.parkingSelector.status.unbound': '未绑定',
  'pages.open-service.parkingSelector.status.available': '可用',
  'pages.open-service.parkingSelector.status.sold': '已售',
  'pages.open-service.parkingSelector.status.rented': '已租',
  'pages.open-service.parkingSelector.status.reserved': '预留',
  'pages.open-service.parkingSelector.status.disabled': '停用',
  'pages.open-service.parkingSelector.action.select': '选择',
  'pages.open-service.parkingSelector.action.confirm': '确认选择',
  'pages.open-service.parkingSelector.action.cancel': '取消',
  'pages.open-service.parkingSelector.message.selectParking':
    '请选择一个停车位',
  'pages.open-service.parkingSelector.message.notSoldOrRented':
    '该车位未售出或未租出',
  'pages.open-service.parkingSelector.message.hasVehicle': '该车位已绑定车辆',
  'pages.open-service.parkingSelector.message.notAvailable': '该车位不可用',
  'pages.open-service.parkingSelector.message.sold': '该车位已售出，不可选择',
  'pages.open-service.parkingSelector.error.loadTree': '加载停车位层级结构失败',
  'pages.open-service.parkingSelector.error.loadList': '加载停车位列表失败',
  'pages.open-service.parkingSelector.error.loadOwnerList': '加载业主列表失败',
  'pages.open-service.parkingSelector.error.loadServiceList':
    '加载服务列表失败',
  'pages.open-service.parkingSelector.pagination.total': '共 {total} 条',
  'pages.open-service.parkingSelector.table.empty.selectArea':
    '请先在左侧选择停车位区域',
  'pages.open-service.parkingSelector.table.empty.noParking':
    '该区域暂无停车位',
  'pages.open-service.parkingSelector.table.empty.noData': '暂无数据',

  // 计费相关
  'pages.open-service.billing.cycle.daily': '按日',
  'pages.open-service.billing.cycle.monthly': '按月',
  'pages.open-service.billing.cycle.quarterly': '按季度',
  'pages.open-service.billing.cycle.yearly': '按年',
  'pages.open-service.billing.unit.month': '月',
  'pages.open-service.billing.unit.day': '日',
  'pages.open-service.billing.unit.year': '年',
  'pages.open-service.billing.unit.unit': '户',
  'pages.open-service.billing.unit.square_meter': '平方米',

  // 通用
  'pages.open-service.common.loading': '加载中...',
  'pages.open-service.common.selectServiceCategory': '请选择服务分类',
  'pages.open-service.common.selectServiceItem': '请选择要开通的服务项',
  'pages.open-service.common.unknown': '未知',
};
